import React, { Fragment, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Collapse, Table } from 'reactstrap';
import dateFormat from "dateformat";
import moment from "moment";

import BreadCrumb from '../components/Common/BreadCrumb';
import CardLoader from "../components/CardLoader";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";

import * as ineCalendarActions from "../actions/IneCalendarActions";

const IneCalendar  = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loading = useSelector((state) => state.calendar.loading);
    const fbo = useSelector((state) => state.calendar.fbo);
    const filter = useSelector((state) => state.calendar.filter);

    const [events, setEvents] = React.useState([]);
    const [selectedEvent, setSelectedEvent] = React.useState(null);

    React.useEffect(() => {
        dispatch(ineCalendarActions.loadIneCalendarSearch(filter, navigate));
    }, []);

    React.useEffect(() => {
        if(fbo && fbo.calendarList) {
            var items = [];
            
            fbo.calendarList.forEach(element => {
                element.start = getFormattedDateTime(element.start);
                element.endDate = getFormattedDateTime(element.end);
                element.end = getFormattedDateTime(new Date(moment(element.end).add(1,'days')));
                items.push(element);
            });

            setEvents(items);
        }
    }, [fbo]);

    const getFormattedDateTime = (value) => {
        if(value) {
            //return dateFormat(value, "yyyy-mm-dd HH:MM");
            return dateFormat(value, "yyyy-mm-dd");
        }
        return "";
    }

    const getColorForInspector = (name) => {
        // const colors = [
        //     "#357D24", "#4C67BD", "#E67E22", "#8E44AD", "#1ABC9C", "#C0392B", "#F39C12", "#2C3E50",
        //     "#16A085", "#27AE60", "#2980B9", "#8E44AD", "#2ECC71", "#E74C3C", "#9B59B6", "#34495E",
        //     "#7F8C8D", "#D35400", "#1ABC9C", "#E67E22"
        // ];

        // let hash = 0;
        // for (let i = 0; i < name.length; i++) {
        //     hash = name.charCodeAt(i) + ((hash << 5) - hash);
        // }

        // const index = Math.abs(hash) % colors.length;
        // return colors[index];

        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = Math.abs(hash) % 360; // full hue range
        return `hsl(${hue}, 65%, 50%)`;
    }

    const inspectors = useMemo(() => {
        const uniqueInspectors = [...new Set(events.map(e => e.inspectorName))];
        const colorMap = {};
        uniqueInspectors.forEach(name => {
            colorMap[name] = getColorForInspector(name);
        });
        return colorMap;
    }, [events]);

    const renderEventContent = (info, inspectors) => {
        const inspector = info.event.extendedProps?.inspectorName;
        const totalHour = info.event.extendedProps?.totalHour;
        const bg = inspectors[inspector] || "#999";

        return (
            <Fragment>
                <div
                    style={{
                        backgroundColor: bg,
                        color: "white",
                        borderRadius: "6px",
                        padding: "5px",
                        fontSize: "0.85rem",
                        //lineHeight: "1.2",
                        
                        whiteSpace: "normal",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflowWrap: "anywhere",
                        maxWidth: "100%",
                        boxSizing: "border-box",
                        
                        cursor: "pointer"
                    }}
                    title={`${inspector} (${totalHour})`}
                    >
                    <strong>{inspector} ({totalHour})</strong>
                </div>
            </Fragment>
        )
    }

    const eventClick = (info) => {
        setSelectedEvent(info.event);
    }
    
    return(
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Calendar" />
                <Row>
                    <Col xl={12}>
                        <CardLoader loading={loading} />
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Calendar</h5>      
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    <FullCalendar
                                        plugins={[dayGridPlugin, interactionPlugin]}
                                        initialView='dayGridMonth'
                                        headerToolbar={{
                                            left: "prev,next today",
                                            center: "title",
                                            right: "dayGridMonth,dayGridWeek,dayGridDay",
                                        }}
                                        buttonText={{
                                            today: "Today",
                                            month: "Month View",
                                            week: "Week View",
                                            day: "Day View",
                                        }}
                                        weekends={true}
                                        events={events}
                                        eventContent={(info) => renderEventContent(info, inspectors)}
                                        eventDidMount={(info) => {
                                            info.el.style.backgroundColor = 'transparent';
                                            info.el.style.cursor = 'pointer';
                                        }}
                                        eventClick={(info) => eventClick(info)}
                                    />

                                    {selectedEvent && (
                                    <div
                                        style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100vw",
                                        height: "100vh",
                                        background: "rgba(0,0,0,0.5)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 9999,  // ✅ ensures it’s above FullCalendar
                                        }}
                                        onClick={() => setSelectedEvent(null)}
                                    >
                                        <div
                                            style={{
                                            background: "white",
                                            padding: "20px 30px",
                                            borderRadius: "8px",
                                            width: "400px",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                                            zIndex: 10000,
                                            }}
                                            onClick={(e) => e.stopPropagation()} // prevent overlay click close
                                        >
                                            <p><b>Ticket #:</b> {selectedEvent.extendedProps?.requestNumber}</p>
                                            <p><b>Inspector Name:</b> {selectedEvent.extendedProps?.inspectorName}</p>
                                            <p><b>Inspector Email:</b> {selectedEvent.extendedProps?.inspectorEmail}</p>
                                            <p><b>Start Date:</b> {getFormattedDateTime(selectedEvent.start)}</p>
                                            <p><b>End Date:</b> {getFormattedDateTime(selectedEvent.extendedProps?.endDate)}</p>
                                            <p><b>Site Location:</b> {selectedEvent.extendedProps?.siteContactLocation}</p>
                                            <hr></hr>
                                            <p><b>Standard Daily Hours:</b> {"8"} hrs</p>
                                            <p><b>Assigned Hours:</b> {selectedEvent.extendedProps?.grandTotalHour} hrs</p>
                                            <p className="text-danger"><b>Accumulative Overtime Hours:</b> {selectedEvent.extendedProps?.overtime} hrs</p>
                                            <button
                                                style={{
                                                marginTop: "10px",
                                                backgroundColor: "#357D24",
                                                color: "white",
                                                border: "none",
                                                padding: "6px 12px",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                }}
                                                onClick={() => setSelectedEvent(null)}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                    )}
                                    
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default IneCalendar;
